module.exports = __webpack_public_path__ + "media/img/uploads/event-thumb-default-5bec75190d482e46d3e25aed4b01d952.jpg";